document.addEventListener("DOMContentLoaded", function () {
    const description = document.querySelector(".product__description");

    if (description && description.scrollHeight > 150) {
        const btn = document.createElement("div");
        btn.classList.add("show-more-btn");
        btn.textContent = "Afficher plus";

        description.after(btn);

        btn.addEventListener("click", function () {
            description.classList.toggle("expanded");
            btn.textContent = description.classList.contains("expanded") ? "Afficher moins" : "Afficher plus";
        });
    }
});